export const SpaceAdminService = Symbol('SpaceAdminService');
